<div class="pt-3 d-flex align-items-center justify-content-end">
  <ng-container *ngIf="showReportFeedback">
    <a class="has-tooltip feedback-icon mx-2 icon-like2" href="javascript:void(0)" (click)="_likeDislike(1)"
      [class.active]="userFeedback && userFeedback.isliked && userFeedback.isliked == 1">
      <span style="min-width: 60px;" class="custom-tooltip">Yes</span>
    </a>
    <a class="has-tooltip feedback-icon mx-2 icon-dislike" href="javascript:void(0)" (click)="_likeDislike(2)"
      [class.active]="userFeedback && userFeedback.isliked && userFeedback.isliked == 2">
      <span style="min-width: 60px;" class="custom-tooltip">No</span>
    </a>
    <a class="has-tooltip mx-2" href="javascript:void(0)" (click)="_reportFeedback()">Was this explanation helpful ?</a>
  </ng-container>
  <ng-container *ngIf="!showReportFeedback && assessmentResult">
    <div>
      <div [class.text-danger]="assessmentResult<0" [class.text-success]="assessmentResult>0">You marked a growth of <strong>{{assessmentResult  | number:'1.0-0'}}%</strong></div>
    </div>
  </ng-container>
</div>
